import React, {useContext, useState} from 'react';
import LazyLoad from 'react-lazyload';
import {PropertiesContext} from "@providers/properties";
import {FilterContext} from "@providers/filters";
import SearchFilters from "../filters/search.filters";
import ModalSearchFilters from "../filters/modal.search.filters";
import {checkFiltersForRedirect} from "@models/search";
import {httpBuildQuery} from "@helpers/helpers";
import {pluckKeyToArray} from "../../hooks/selection.options";

const SearchFiltersAndModalFilters = ({isBadeSaba, handleGetProperties, searchNavbarRef, handleRedirectFilters, showLanding, setShowLanding, setSkeleton}) => {
    const [modalFiltersShow, setModalFiltersShow] = useState(false);

    // contexts
    const properties_context = useContext(PropertiesContext);
    const filters = useContext(FilterContext);

    // useEffects


    const handleModalFiltersShow = async (val, get_properties = false) => {
        setModalFiltersShow(val);

        const checkRedirect = await checkFiltersForRedirect(filters.selected_filters, isBadeSaba);

        if (checkRedirect.redirect) {
            handleRedirectFilters(checkRedirect)
        } else {
            let $params = JSON.parse(JSON.stringify(filters.selected_filters)); // deep copy
            $params['district_id'] = pluckKeyToArray($params['district_id'], 'value');

            let route = '/search/v1/properties?page=1&';
            route += httpBuildQuery($params);

            if (route !== properties_context.last_route || showLanding) {
                setShowLanding('');
                setSkeleton(true);

                setTimeout(() => {
                    handleGetProperties('ADD_NEW', true)
                }, 400)
            }
        }
    };

    return (
        <React.Fragment>
            <LazyLoad once>
                <SearchFilters
                    isBadeSaba={isBadeSaba}
                    searchNavbarRef={searchNavbarRef}
                    setModalFiltersShow={setModalFiltersShow}
                />
            </LazyLoad>

            <LazyLoad once>
                <ModalSearchFilters
                    isBadeSaba={isBadeSaba}
                    setModalFiltersShow={handleModalFiltersShow}
                    show={modalFiltersShow}
                />
            </LazyLoad>
        </React.Fragment>
    );
};

export default React.memo(SearchFiltersAndModalFilters);
